
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from '../../../api-gateway';
import { Fee } from '../../../models/backend-definitions.module';
import { SnackBarService } from '../../../../cw-utils/snackbar.service';

@Injectable()
export class FeeEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    fee: Fee;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise<void>((resolve, reject) => {
            Promise.all([this.getFee()]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    getFee(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('fee/wAll/' + this.routeParams.id).subscribe((res: Fee ) => {
                    this.fee = res;
                    this.onDataChanged.next(this.fee);
                    resolve(res);
                }, reject);
            }
        });
    }

    insert(fee): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('fee/', fee).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    edit(fee): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.put('fee/', fee).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }

    delete(fee): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('fee/' + fee.id).subscribe((response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, reject);
        });
    }
}
